import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

const BlogCard = ({ image, title, link }) => {
  return (
    <div className="blog-card">
      <div className="blog-image-wrapper">
        <img src={image} alt={title} className="blog-image" />
      </div>
      <div className="blog-content">
        <h3 className="blog-title">{title}</h3>
        <a href={link} className="blog-learn-more">
          Learn More
          <FaArrowRight />
        </a>
      </div>
    </div>
  );
};

export default BlogCard;
